import React from 'react';
import { HdSupportButton } from '../../../../support/components/support-button/SupportButton';
import { useObservableState } from '../../../../core/hooks/useObservableState';
import useService from '../../../../injector/hooks/useService';
import { getUnreadDisplayCount } from '../../../../core/utils/string';
import { TRACKER_SUPPORT_CTA_CLICK } from '../../../../core/constants/constants';
import { EnvConfig } from '../../../../core/env-config';
import { SupportService } from '../../../../support/interfaces/support';
import { TeamService } from '../../../../core/services/team.service';
import { AppbarSupportCTA } from './AppbarSupportCTA';
import { AppbarSupportCTAWithMenu } from './AppbarSupportCTAWithMenu';
export function AppbarSupportBtnWrapper() {
  const teamDetailsService = useService(TeamService);
  const supportService = useService(SupportService);

  const isTeamInTrial = teamDetailsService.teamDetails.status === 'TRIAL';
  const [supportUnreadCount] = useObservableState(supportService.unreadCount$);
  const [canShowOnCallSupportIndicator] = useObservableState(
    supportService.isOnCallSupportAvailable$
  );
  const [supportPersonImageURL] = useObservableState(supportService.onCallSupportPersonImage$);

  return (
    <>
      
      {isTeamInTrial || !EnvConfig.isCombinedSupportOptionsEnabled() ? (
        <HdSupportButton
          label='Live Chat'
          badgeContent={supportUnreadCount ? getUnreadDisplayCount(supportUnreadCount) : null}
          showOnCallSupportIndicator={canShowOnCallSupportIndicator}
          supportPersonImageURL={supportPersonImageURL}
          trackingEvent={TRACKER_SUPPORT_CTA_CLICK}
          Component={AppbarSupportCTA}
        />
      ) : (
        <AppbarSupportCTAWithMenu
          supportUnreadCount={supportUnreadCount}
          canShowOnCallSupportIndicator={canShowOnCallSupportIndicator}
        />
      )}
    </>
  );
}
